import React from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import Typography from '@mui/material/Typography';
import { monoSx } from '../dashboard/styles';

interface FilterFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

const FilterField: React.FC<FilterFieldProps> = ({ label, placeholder, value, onChange }) => (
  <Box component="label" sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
    <Typography component="span" sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>
      {label}
    </Typography>
    <InputBase
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      sx={{
        ...monoSx,
        height: 44,
        px: 1.75,
        fontSize: 13,
        borderRadius: 2.5,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        '&.Mui-focused': { borderColor: 'primary.dark' },
      }}
    />
  </Box>
);

interface UrlFilterFieldsProps {
  tags: string;
  operationIds: string;
  onTagsChange: (value: string) => void;
  onOperationIdsChange: (value: string) => void;
}

/** Free-text filters for a URL spec; the spec isn't fetched until the job runs, so there's nothing to pick from. */
const UrlFilterFields: React.FC<UrlFilterFieldsProps> = ({ tags, operationIds, onTagsChange, onOperationIdsChange }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>Comma-separated. Leave empty to include everything.</Typography>
    <FilterField label="Tags" placeholder="orders, users, products" value={tags} onChange={onTagsChange} />
    <FilterField label="Operation IDs" placeholder="getOrders, createUser, updateProduct" value={operationIds} onChange={onOperationIdsChange} />
  </Box>
);

export default UrlFilterFields;
